import axios from 'axios'

const instance = axios.create()

export default instance



// WEBPACK FOOTER //
// ./src/axios/config.js